module.exports = __webpack_public_path__ + "img/logo.5a5fd6de.png";